// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"590":"58465788","656":"4bdd2dcb"}[chunkId] + ".chunk.css";
};